/**
 * Schema lungo (3.x / 4.0.x / 5.x) vs corto (4.1.x) sui punti live history.json.
 * Non riallunga il file su CDN: copia i nomi lunghi solo in memoria.
 */

function copyAliases(obj, map) {
    if (!obj || typeof obj !== 'object') return obj;
    Object.keys(map).forEach((legacy) => {
        const shortKey = map[legacy];
        if (obj[legacy] === undefined && obj[shortKey] !== undefined) {
            obj[legacy] = obj[shortKey];
        }
    });
    return obj;
}

const ALIASES_INFO = { MISSION_NUM: 'MSN', PKT_NUM: 'PKTN', STATUS: 'STAT' };
const ALIASES_POINTS = {
    LATITUDE: 'LAT', LONGITUDE: 'LON', ALTITUDE: 'ALT', HEADING: 'HEAD',
    FIX_MODE: 'FIX', LIDAR_DISTANCE: 'LIDAR_RNG', NUM_BURN_POINTS: 'N_BURN_PNTS',
};
const ALIASES_TIME = {
    YEAR: 'YYYY', MONTH: 'MM', DAY: 'DD', HOUR: 'hh',
    MINUTE: 'mm', SECOND: 'ss', MILLISECOND: 'ms',
};
const ALIASES_TELEM = { IR_STATUS: 'IR', LIDAR_STATUS: 'LIDAR', RGB_STATUS: 'RGB' };
const ALIASES_IMGS = { IR_IMAGE: 'IR', RGB_IMAGE: 'RGB', NUM_BURN_POINTS: 'N_BURN_PNTS' };
const ALIASES_STAT = { STATUS: 'STAT' };
const ALIASES_VIDEO = { PREFIX: 'PRFX', STATUS: 'STAT', TIME: 'T0' };
const ALIASES_DROP = { TODO: 'STAT', STATUS: 'STAT' };

export function hydrateLivePoint(point) {
    if (!point || typeof point !== 'object') {
        return point;
    }

    if (point.info) copyAliases(point.info, ALIASES_INFO);
    if (point.points) copyAliases(point.points, ALIASES_POINTS);
    if (point.time) copyAliases(point.time, ALIASES_TIME);
    if (point.s_status && !point.telemetria) {
        point.telemetria = point.s_status;
    }
    if (point.telemetria) copyAliases(point.telemetria, ALIASES_TELEM);
    if (point.imgs && !point.images) {
        point.images = point.imgs;
    }
    if (point.images) copyAliases(point.images, ALIASES_IMGS);
    if (point.stream && !point.streaming) {
        point.streaming = point.stream;
    }
    if (point.streaming) copyAliases(point.streaming, ALIASES_STAT);
    if (point.video) copyAliases(point.video, ALIASES_VIDEO);
    if (point.drop) copyAliases(point.drop, ALIASES_DROP);
    if (point.contour) copyAliases(point.contour, ALIASES_STAT);
    if (point.photogr && !point.photogrammetry) {
        point.photogrammetry = point.photogr;
    }
    if (Array.isArray(point.fires)) {
        point.fires.forEach((f) => copyAliases(f, ALIASES_POINTS));
    }

    return point;
}

export function hydrateHistoryPayload(data) {
    if (!data || !Array.isArray(data.points)) {
        return data;
    }
    data.points.forEach((wrap) => {
        if (wrap && wrap.point) {
            hydrateLivePoint(wrap.point);
        }
    });
    return data;
}
